module.exports = __webpack_public_path__ + "img/bohui.8591974f.png";